'use strict';

const h = require('phy');
const Tag = require('@design-system/ui-icons/preact/Tag').default;

const applyCode = props => {
  const {
    applyCodeText,
    handleApplyClick,
    promoAdditionalMessage,
    promoMessage,
    touchRequest,
  } = props;

  return h(
    '.apply-code-wrapper',
    h(
      '.promo-v2-icon-message-wrapper',
      !touchRequest &&
        h(Tag, {
          focusable: 'false',
          role: 'img',
          'aria-labelledby': 'promo-v2-message',
        }),
      h(
        `.promo-v2-message#promo-v2-message`,
        promoMessage,
        h('.promo-v2-additional-message', {
          dangerouslySetInnerHTML: { __html: promoAdditionalMessage },
        })
      )
    ),
    h(
      '.apply-code',
      {
        'data-bhw': 'ClickToApplyPromoCode',
        'data-bh-viewport': 'respect',
        onClick: handleApplyClick,
      },
      applyCodeText
    )
  );
};

module.exports = applyCode;
